import { domainUrl } from '../constants';

export const API_GET_SINGLE_PAGES = `${domainUrl}cms-pages`;
export const API_GET_SINGLE_PAGE_DETAIL = `${domainUrl}cms-pages/{id}`;
